import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteDocument from 'hooks/document/useDeleteDocument';
import { DocumentList } from 'types';
import notificationHandler from 'utils/notifications';

interface IDeleteIssuedDocumentModalProps {
  document: DocumentList;
  opened: boolean;
  closeHandler: () => void;
}

const DeleteIssuedDocumentModal = ({
  document,
  opened,
  closeHandler,
}: IDeleteIssuedDocumentModalProps): JSX.Element => {
  const deleteDocumentMutation = useDeleteDocument();

  const handleDelete = (): void => {
    if (document.documentId && document.signedDate === null) {
      const { successNotification, errorNotification } = notificationHandler();
      deleteDocumentMutation.mutate(document.documentId, {
        onSuccess: () => {
          successNotification('Document delete success', `${document.description} successfully deleted.`);
        },
        onError: error => {
          errorNotification('Document delete failed', error.response?.data.message);
        },
        onSettled: () => {
          closeHandler();
        },
      });
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={closeHandler}
      title={<Title order={4}>Delete {document.description}</Title>}
      size='auto'
      trapFocus
      centered
    >
      <Stack>
        <Text>{`Are you sure you want to delete ${document.description}?`}</Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button
            onClick={handleDelete}
            color='red'
            disabled={deleteDocumentMutation.isLoading}
            data-cy='confirmDeleteIssueDocument'
          >
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default DeleteIssuedDocumentModal;
